import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { DIALOG_CLOSE_BUTTON_SX } from "../../../constants/dialogCloseButtonStyles";
import type { ImplementationRecord } from "../../../services/implementationRecordService";
import { withoutBackdropClose } from "../../../utils/withoutBackdropClose";
import ImplementationRecordDetailContent from "./ImplementationRecordDetailContent";

type ImplementationRecordDetailDialogProps = Readonly<{
  open: boolean;
  record: ImplementationRecord | null;
  onClose: () => void;
}>;

export default function ImplementationRecordDetailDialog({
  open,
  record,
  onClose,
}: ImplementationRecordDetailDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={withoutBackdropClose(onClose)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          px: 3,
          pt: 2.5,
          pb: 1.5,
        }}
      >
        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#101828" }}>
          Details
        </Typography>
        <IconButton aria-label="Close" onClick={onClose} sx={DIALOG_CLOSE_BUTTON_SX}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 3, pb: 3, pt: 0 }}>
        {record ? <ImplementationRecordDetailContent record={record} /> : null}
      </DialogContent>
    </Dialog>
  );
}
